import React from "react";
import { Table } from "components";
import PropTypes from "prop-types";
import { Row, Col, Button, message } from "antd";
import { List, OrderedMap, Map } from "immutable";
import { onCellGenerator } from "constants/table-columns";
import { LEDGER_DATA_SOURCE } from "./constants/enums";
import { TABLE_DATA_TYPES } from "constants/table-data-types";
import CompanyService from "services/company-service";

const getCibilEligibility = (gstin) => {
    const body = {
        "gstin": gstin
    };
    CompanyService.getCompanyCustomereCibilEligibility(body).then(res=>{
        let eligibilityValue = res && res?.data?.cibil_eligibility;
        eligibilityValue !== "Not Found" ? message.success(eligibilityValue) : null;
    }).catch(err => {
        console.log("inside catch cibil eligibility", err);
    });
};

function checkCibilEligibility(_, record) {
    const gstin = record && record?.gstin;
    return <Button value={gstin} disabled={!_} onClick={() => getCibilEligibility(gstin)}>Check Eligibility</Button>;
}

const LEDGER_MASTER_COLS = new OrderedMap({
    name: {
        title: "Name",
        dataIndex: "name",
        key: "name",
        editable: false,
        onCellGenerator,
        dataType: TABLE_DATA_TYPES.STRING
    },
    gstin: {
        title: "GSTIN",
        dataIndex: "gstin",
        key: "gstin",
        editable: true,
        dataType: TABLE_DATA_TYPES.STRING,
        onCellGenerator
    },
    data_source_type: {
        title: "Source",
        dataIndex: "data_source_type",
        key: "data_source_type",
        editable: false,
        onCellGenerator,
        dataType: TABLE_DATA_TYPES.ENUM,
        enum: LEDGER_DATA_SOURCE,
        notFilterApplicable: true,
        render: _ => LEDGER_DATA_SOURCE.findKey(__ => __ == _)
    },
    check_eligiblity: {
        title: "Check Eligibility",
        dataIndex: "is_cibil_required",
        key: "is_cibil_required",
        editable: false,
        onCellGenerator,
        notFilterApplicable: true,
        render: (_, record) => checkCibilEligibility(_, record)
    },
    cibil_eligiblity: {
        title: "Cibil Eligibility",
        dataIndex: "cibil_eligibility",
        key: "cibil_eligibility",
        editable: false,
        onCellGenerator,
        notFilterApplicable: true,
    },
});

class CompanyLedgerMaster extends React.Component {

    state = {
        updatedLedgerEntries: new Map({})
    };  

    componentDidMount() {
        this.props.fetchSellerLedgerMaster(this.props.companyId);
    }

    updateLedgerEntries = () => {
        if(this.state.updatedLedgerEntries && this.state.updatedLedgerEntries.size) {
            this.props.updateSellerLedgerMaster(this.props.companyId, this.state.updatedLedgerEntries.toList().toArray());
        }
    }

    handleSaveMultipleEntries = (record, values) => {
        record.gstin = values.gstin;
        this.setState({
            updatedLedgerEntries: this.state.updatedLedgerEntries.set(record.id, {
                id: record.id,
                ...values
            })
        });
    }

    onFilter = (values) => {
        this.filterObj = {};
        new Map(values).map((_, k) => {
            this.filterObj[k] = _ && _[0];
        });
        this.props.fetchSellerLedgerMaster(this.props.companyId, this.filterObj);
    }

    render() {
        return (
            <Row>
                <Col offset={3} span={18} className={"mb-10"}>
                    <Table
                        showFilters={true}
                        columns={LEDGER_MASTER_COLS.map(({ onCellGenerator, editable, ...restColFields}) => {
                            if (!onCellGenerator || !editable) {
                                return { ...restColFields };
                            }
                            return {
                                onCell: onCellGenerator(
                                    this.handleSaveMultipleEntries,
                                    restColFields
                                ),
                                ...restColFields
                            };
                        })}
                        spanConfig={{
                            filters: 12,
                            btnSpan: 12
                        }}
                        showTopSection={true}
                        noRowSelection={true}
                        data={(this.props.sellerLedgerMasters && this.props.sellerLedgerMasters.toList()) || new List([])}
                        editable={true}
                        pagination={false}
                        onFilter={this.onFilter}
                        tablePagination={true}
                    />
                </Col>
                <Col offset={3} span={18} className={"d-flex flex-row-reverse"}>
                    <Button type={"primary"} onClick={this.updateLedgerEntries}>
                        Update
                    </Button>
                </Col>
            </Row>
        );
    }

}

CompanyLedgerMaster.propTypes = {
    companyId: PropTypes.number,
    updateSellerLedgerMaster: PropTypes.func,
    sellerLedgerMasters: PropTypes.func,
    fetchSellerLedgerMaster: PropTypes.func,

};

export default CompanyLedgerMaster;